import React from 'react'
import PropTypes from 'prop-types'

import ReCAPTCHA from 'react-google-recaptcha'

import { AppWrapper, Input, Modal } from 'passiv-components'

const Forgot = ({
  register,
  done,
  error,
  siteKey,
  disabled,
  onRecaptcha,
  onBack,
  onReset,
  onClickDone,
  onClearError
}) => {

  const errorMessage =
    error === 'INTERNET' || error === 'SERVER'
      ? 'Your device is having trouble connecting to our servers. Please ensure your device is connected to the internet to continue using the app.'
      : 'The username you entered is incorrect.\nYou will be locked out for 20 minutes after three attempts.'

  const modalButtons =
    [
      {
        name: 'ok',
        text: 'Ok',
        onClick: onClearError
      }
    ]

  // todo: https://www.passivsystems.com/trouble_logging_on
  return (
    <AppWrapper
      dataContainer="forgot"
      titleHeader="Reset Password"
      titleContainer="Please follow the steps below to create a new password"
      buttons={[
        {
          name: 'reset-password',
          text: 'Reset Password',
          disabled,
          onClick: onReset
        }
      ]}
      renderPortal={
        error
        ? () => (
          <Modal
            id="error"
            open={true}
            type="alert"
            title={(error === 'INTERNET' || error === 'SERVER') ? "Something's wrong" : "Error"}
            text={errorMessage}
            buttons={modalButtons}
          />
        )
        : done
        ? () => (
            <Modal
              id="modal-almost-done"
              open={true}
              type="info"
              title="Almost Done!"
              text="We have sent you an email containing a link to reset your password. If you don’t receive the email, please make sure to check your junk and spam folders. Don’t worry if you get stuck you can call our customer support team."
              buttons={[
                {
                  name: 'ok',
                  text: 'Ok',
                  onClick: onClickDone
                }
              ]}
            />
          )
        : null
      }
      onBack={onBack}
    >
      {/* todo: bring over username from login as defaultValue */}
      <Input
        ref={register({ required: true })}
        type="email"
        name="username"
        label="Username"
        className="border-b border-border-dark mb-1"
      />

      {siteKey && <ReCAPTCHA className="mb-2 mt-3" sitekey={siteKey} onChange={onRecaptcha} />}
    </AppWrapper>
  )
}

Forgot.propTypes = {
  register: PropTypes.func,
  done: PropTypes.bool,
  siteKey: PropTypes.string,
  disabled: PropTypes.bool,
  onRecaptcha: PropTypes.func,
  onReset: PropTypes.func,
  onBack: PropTypes.func,
  onClickDone: PropTypes.func
}

export default Forgot
